var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_5664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 11.2V13.6C7.2 14.9199 6.11992 16 4.8 16H2.4C1.08008 16 0 14.9199 0 13.6V11.2C0 9.88008 1.08008 8.8 2.4 8.8H4.8C6.11992 8.8 7.2 9.88008 7.2 11.2ZM7.2 2.4V4.8C7.2 6.11992 6.11992 7.2 4.8 7.2H2.4C1.08008 7.2 0 6.11992 0 4.8V2.4C0 1.08008 1.08008 0 2.4 0H4.8C6.11992 0 7.2 1.08008 7.2 2.4ZM16 11.2V13.6C16 14.9199 14.9199 16 13.6 16H11.2C9.88008 16 8.8 14.9199 8.8 13.6V11.2C8.8 9.88008 9.88008 8.8 11.2 8.8H13.6C14.9199 8.8 16 9.88008 16 11.2ZM16 2.4V4.8C16 6.11992 14.9199 7.2 13.6 7.2H11.2C9.88008 7.2 8.8 6.11992 8.8 4.8V2.4C8.8 1.08008 9.88008 0 11.2 0H13.6C14.9199 0 16 1.08008 16 2.4Z",
    fill: "#353A41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_5664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOptions);
export default __webpack_public_path__ + "static/media/all-options.ba8cdd9799c5822499b797862625e851.svg";
export { ForwardRef as ReactComponent };